import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import { loggedUser, logout } from "../../redux/authSlice";
const ProtectedRoute = ({ element, allowedRoles }) => {
  const { user } = useSelector((state) => state.auth);
  if (process.env.NODE_ENV === "development") {
    console.log("ProtectedRoute user", user);
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return element;
};

export default ProtectedRoute;
